import { RoutineType } from '../../../../graphql';

export interface RoutineTriggerConfig {
  workspaceRoutineId: string;
  onCompletionCount?: number;
  daysSinceCompleted?: number;
  every?: number;
  routineType: RoutineType;
  onDate?: Date;
}
